import { render, staticRenderFns } from "./UserBeaconsLocation.vue?vue&type=template&id=045048e8&"
import script from "./UserBeaconsLocation.vue?vue&type=script&lang=js&"
export * from "./UserBeaconsLocation.vue?vue&type=script&lang=js&"
import style0 from "./UserBeaconsLocation.vue?vue&type=style&index=0&id=045048e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports